import React from 'react'
import { Link } from "react-router-dom";
import "../App.css"
import axios from "axios";
import Path from "./config";
class NavFormProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sbg_personal: true,
            sbg_edu: false,
            sbg_income: '',
            sbg_family: '',
            sbg_relative: '',
            sbg_asset: '',
            sbg_upload: '',
            sbg_post_address: '',
            admin: '',
            adminid: ''

        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("adminid")
        })

        //console.log (localStorage.getItem("adminid"));

        axios.get(Path + 'Suchi_bride_groom_show_status.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                response = response.data;
                // console.log(response)
                this.setState({
                    sbg_approved_status: response.sbg_office_appoved_status,
                    sbg_first_name: response.sbg_first_name,
                    sbg_admin_approved_status: response.sbg_admin_approved_status,
                    sbg_edu: response.sbg_edu,
                    sbg_income: response.sbg_income,
                    sbg_family: response.sbg_family,
                    sbg_relative: response.sbg_relative,
                    sbg_asset: response.sbg_asset,
                    sbg_upload: response.sbg_upload,
                    sbg_post_address: response.sbg_post_address,
                    sbg_summery: response.sbg_summery
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }
    render() {
        let status = "";
        if (this.state.sbg_approved_status === "0") {
            status = <span className="text-danger  font-weight-bold">  SAP </span>
        }
        else if (this.state.sbg_approved_status === "1") {
            status = <span className="text-success  font-weight-bold">  SAC </span>
        }

        let adminStatus = "";
        if (this.state.sbg_admin_approved_status === "0") {
            adminStatus = <span className="text-danger font-weight-bold">   AP </span>
        }
        else if (this.state.sbg_admin_approved_status === "1") {
            adminStatus = <span className="text-success  font-weight-bold">    AC </span>
        }

        let infoStatus = "";
        if (this.state.sbg_edu === "1" && this.state.sbg_income === "1" && this.state.sbg_family === "1" && this.state.sbg_relative === "1" &&
            this.state.sbg_asset === "1" && this.state.sbg_upload === "1" && this.state.sbg_post_address === "1" &&
            this.state.sbg_summery === "1") {
            infoStatus = <span className="text-success  font-weight-bold">  IC </span>
        }
        else {
            infoStatus = <span className="text-danger  font-weight-bold">  II</span>
        }



        // let sbg_edu1 ="";

        // if(this.state.sbg_edu ===  "1")
        // {
        //     sbg_edu1 = <Link to={`/AdminProfile/EducationInfo`} className="btn btn-primary active selectmenu" >शिक्षण  </Link>
        // }
        // else{

        //     sbg_edu1 = <span className="btn btn-light active selectmenu" >शिक्षण  </span>
        // }

        // let sbg_income1 ="";
        // if(this.state.sbg_income ===  "1")
        // {
        //     sbg_income1 =   <Link to={`/AdminProfile/IncomeInfo`} className="btn btn-primary active selectmenu" >उत्पन्न विषयीची माहिती  </Link>

        // }
        // else{

        //     sbg_income1 = <span  className="btn btn-light active selectmenu" >उत्पन्न विषयीची माहिती  </span>

        // }

        // let sbg_family1="";
        // if(this.state.sbg_family ===  "1")
        // {
        //     sbg_family1 = <Link to={`/AdminProfile/FamilyInfo`} className="btn btn-primary active" >कौटुंबिक माहिती  </Link>
        // }
        // else{

        //     sbg_family1 = <span  className="btn btn-light active" >कौटुंबिक माहिती  </span>
        // }

        // let sbg_relative1="";
        // if(this.state.sbg_relative ===  "1")
        // {
        //     sbg_relative1 = <Link to={`/AdminProfile/ContactInfo/`} className="btn btn-primary active" >संपर्कासाठीची नावे </Link>
        // }
        // else{

        //     sbg_relative1 = <span  className="btn btn-light active" >संपर्कासाठीची नावे </span>
        // }

        // let sbg_asset1="";
        // if(this.state.sbg_asset ===  "1")
        // {
        //     sbg_asset1 = <Link to={`/AdminProfile/AssetInfo`} className="btn btn-primary active" >स्थावर मालमत्ता </Link>
        // }
        // else{

        //     sbg_asset1 = <span className="btn btn-light active" >स्थावर मालमत्ता </span>
        // }

        // let sbg_upload1="";
        // if(this.state.sbg_upload ===  "1")
        // {
        //     sbg_upload1 = <Link to={`/AdminProfile/UploadDoc`} className="btn btn-primary active" >अपलोड  </Link>
        // }
        // else{

        //     sbg_upload1 = <span  className="btn btn-light active" >अपलोड  </span>
        // }

        // let sbg_post_address1="";
        // if(this.state.sbg_post_address ===  "1")
        // {
        //     sbg_post_address1= <Link to={`/AdminProfile/PostAddress`} className="btn btn-primary active" > पत्ता </Link>
        // }
        // else{

        //     sbg_post_address1= <span  className="btn btn-light active" > पत्ता </span>
        // }

        // let sbg_summery1="";
        // if(this.state.sbg_summery ===  "1")
        // {

        //         sbg_summery1 = 
        //         <Link to={ `/AdminProfile/FullbiodataAdmin`} className="btn btn-primary active" >परिचयपत्र  </Link>

        // }
        // else{

        //     sbg_summery1=  <span className="btn btn-light active" >परिचयपत्र </span>
        // }



        return (
            <>

                <div className="btn-group">
                    <Link to={`/AdminProfile`} ><button className="btn btn-primary active selectmenu ">Basic Registration </button></Link>
                    <Link to={`/AdminProfile/PersonalInfo`} ><button className="btn btn-primary active selectmenu "   >वैयक्तिक माहिती </button></Link>
                    <Link to={`/AdminProfile/EducationInfo`} className="btn btn-primary active selectmenu" >शिक्षण  </Link>
                    <Link to={`/AdminProfile/IncomeInfo`} className="btn btn-primary active selectmenu" >उत्पन्न विषयीची माहिती  </Link>
                    <Link to={`/AdminProfile/FamilyInfo`} className="btn btn-primary active" >कौटुंबिक माहिती  </Link>
                    <Link to={`/AdminProfile/ContactInfo/`} className="btn btn-primary active" >संपर्कासाठीची नावे </Link>
                    <Link to={`/AdminProfile/AssetInfo`} className="btn btn-primary active" >स्थावर मालमत्ता </Link>
                    <Link to={`/AdminProfile/UploadDoc`} className="btn btn-primary active" >अपलोड  </Link>
                    <Link to={`/AdminProfile/PostAddress`} className="btn btn-primary active" > सूची वाटप केंद्र </Link>
                    <Link to={`/AdminProfile/Paddress`} className="btn btn-primary active" > पत्ता </Link>
                    <Link to={`/AdminProfile/FullbiodataAdmin`} className="btn btn-primary active" >परिचयपत्र  </Link>
                </div>

                {/* <div className="btn-group">
                <Link to="/FormProfile" ><button className="btn btn-primary active selectmenu "   >वैयक्तिक माहिती </button></Link>
                <Link to="/FormProfile/EducationInfo" className="btn btn-primary active selectmenu" >शिक्षण  </Link>
                <Link to="/FormProfile/IncomeInfo" className="btn btn-primary active selectmenu" >उत्पन्न विषयीची माहिती  </Link>
                <Link to="/FormProfile/FamilyInfo" className="btn btn-primary active" >कौटुंबिक माहिती  </Link>
                <Link to="/FormProfile/ContactInfo/:sbgr_id" className="btn btn-primary active" >संपर्कासाठीची नावे </Link>
                <Link to="/FormProfile/AssetInfo" className="btn btn-primary active" >स्थावर मालमत्ता </Link>
                <Link to="/FormProfile/UploadDoc" className="btn btn-primary active" >अपलोड  </Link>
                <Link to="/FormProfile/PostAddress" className="btn btn-primary active" >Post Address  </Link>
                <Link to="/FormProfile/All_record_summary" className="btn btn-primary active" >फॉर्म सारांश </Link>
            </div> */}
                <div className="bg-warning container-fluid">
                    <span className=" text-dark text-left p-2">

                        <form className="d-flex">
                            Profile Name: {this.state.sbg_first_name} !! {this.state.phoneId}  &nbsp;&nbsp;&nbsp;
                        </form>
                    </span>
                    <span className="text-dark text-right p-2">
                        {/* <img src={logo} alt="Logo"  style={{width:"200px"}} /> */}
                        Information Status :{infoStatus} &nbsp; &nbsp;||  &nbsp; &nbsp;
                        Submit Status :  {status}  &nbsp; &nbsp; || &nbsp; &nbsp;
                        Admin Status : {adminStatus}
                        {/* <form className="d-flex">
                    Welcome {this.state.sbg_first_name} !! {this.state.phoneId}  &nbsp;&nbsp;&nbsp;
                    <button type="button" className="btn-primary text-light" onClick={()=>this.logouti()} >Logout</button>
                    </form> */}
                    </span>
                </div>

            </>
        )
    }
}

export default NavFormProfile
